import { INPUT_WIDTHS_FOR_TWO_INPUTS_WITH_BULLET_POINT } from '../../constants/inlineLayout';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import { useAssetMembershipCondition } from '../../hooks/useAssetMembershipCondition';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import EditorAssetMembershipCondition from './EditorAssetMembershipCondition';
import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import EditorConditionAsset from './EditorConditionAsset';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import InlineContainerWithEditorConditionActions from '../common/InlineContainerWithEditorConditionActions';
import UISelect from 'UIComponents/input/UISelect';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorAssetMembershipConditionResponsive = ({
  condition,
  conditionPath,
  filterFamily,
  inputUse
}) => {
  const {
    width
  } = useElementSize();
  const {
    onFieldConditionFieldChange
  } = useFieldConditionChange(filterFamily, conditionPath, condition);
  const {
    onConditionDelete,
    onSelectedOptionChange,
    operatorOptions
  } = useAssetMembershipCondition(filterFamily, condition, conditionPath);
  if (width.size === MEDIA_SIZES.sm) {
    return /*#__PURE__*/_jsx(EditorAssetMembershipCondition, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      inputUse: inputUse
    });
  }
  return /*#__PURE__*/_jsxs(ConditionBox, {
    children: [/*#__PURE__*/_jsxs(InlineContainerWithEditorConditionActions, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      hideChangeFieldButton: true,
      onConditionDelete: () => onConditionDelete(conditionPath),
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: `${INPUT_WIDTHS_FOR_TWO_INPUTS_WITH_BULLET_POINT[width.size]}px`
        },
        children: /*#__PURE__*/_jsx(EditorConditionAsset, {
          condition: condition,
          filterFamily: filterFamily,
          inputUse: inputUse,
          onAssetChange: onFieldConditionFieldChange
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          width: `${INPUT_WIDTHS_FOR_TWO_INPUTS_WITH_BULLET_POINT[width.size]}px`
        },
        children: /*#__PURE__*/_jsx(UISelect, {
          "data-selenium-test": "fr-filter-operator-select"
          //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
          ,
          disabled: condition.field && condition.field.userHasNoAccess,
          onSelectedOptionChange: onSelectedOptionChange,
          optionRenderer: option => /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
            message: true,
            option: option
          }),
          options: operatorOptions,
          value: condition.constructor.toString(),
          buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
        })
      })]
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    })]
  });
};
export default EditorAssetMembershipConditionResponsive;